import React, { useEffect, useState } from 'react';
import Switcher from '../../../../../../components/ui/switcher/Switcher';
import clsx from 'clsx';
import { useIsMount } from '../../../../../../hooks/useIsMountHook';

interface Props {
  isActive: boolean;
  label: any;
  onChange: (value: boolean) => void;
  className?: string;
  disabled: boolean;
}

const RunnerActiveSwitch = ({ isActive, label, onChange, className, disabled }: Props) => {
  const [isEnabled, setIsEnabled] = useState(isActive);
  const isMount = useIsMount();

  //Reset select all if data is empty
  useEffect(() => {
    if (!isMount && isActive !== isEnabled) {
      setIsEnabled(isActive);
    }
  }, [isActive]);

  //Reset select all if data is empty
  useEffect(() => {
    if (!isMount && isActive !== isEnabled) {
      onChange(isEnabled);
    }
  }, [isEnabled]);

  return (
    <div className={clsx('d-inline-block', className)}>
      <label htmlFor="recordingMode" className={'mr-4 mt-2'}>
        {label}
      </label>
      <Switcher
        disabled={disabled}
        className={'d-inline-block'}
        label={isEnabled ? 'ON' : 'OFF'}
        size={'md'}
        onChange={() => {
          setIsEnabled(!isEnabled);
        }}
        checked={isEnabled}
      />
    </div>
  );
};

export default RunnerActiveSwitch;
